import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class AuthChildGuard  {

  constructor(private router: Router) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const user = JSON.parse(localStorage.getItem('currentUser') || 'null');
    if (user) {
      // console.log('child')
      // console.log(user);
      // console.log('state', state);
      if(!user.isAdmin && !user.roles.includes('admin') ){
        if(state.url.includes('admin')){
          return this.router.createUrlTree(['/']);
        }
      }
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    // Return a UrlTree instead of calling router.navigate() here - navigating
    // imperatively from inside a guard can be dropped by the router when it
    // conflicts with the in-flight navigation, leaving a blank page.
    return this.router.createUrlTree(['/authentication/login'], { queryParams: { returnUrl: state.url } });
  }
}
